import script from "./Bookings.vue?vue&type=script&setup=true&lang=ts"
export * from "./Bookings.vue?vue&type=script&setup=true&lang=ts"

import "./Bookings.vue?vue&type=style&index=0&id=43e34560&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e34560"]])

export default __exports__